// extracted by mini-css-extract-plugin
export default {"input":"InputText_input__QzrYk","label":"InputText_label__yoT5d","labeldiv":"InputText_labeldiv__-KBhe"};